import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  DateField,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  SelectInput,
} from "react-admin";

const statusChoices = [
  { id: "pending", name: "Pending" },
  { id: "confirmed", name: "Confirmed" },
  { id: "unsubscribed", name: "Unsubscribed" },
];

export const NewsletterSubscriberList = () => (
  <List>
    <Datagrid rowClick="edit">
      <EmailField source="email" />
      <TextField source="status" />
      <BooleanField source="is_active" />
      <TextField source="source" />
      <DateField source="created_at" showTime />
    </Datagrid>
  </List>
);

export const NewsletterSubscriberEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="email" disabled />
      <SelectInput source="status" choices={statusChoices} />
      <BooleanInput source="is_active" />
      <TextInput source="source" />
      <TextInput source="confirmed_at" disabled />
      <TextInput source="unsubscribed_at" disabled />
    </SimpleForm>
  </Edit>
);
